import { supabase } from './supabase';

export async function createBlock({ calibration_id, block_type = null, mode, unit, range_text = null, display_name = null }) {
  const { data, error } = await supabase
    .from('calibration_blocks')
    .insert([{ calibration_id, block_type, mode, unit, range_text, display_name }])
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

export async function listBlocks(calibration_id) {
  const { data, error } = await supabase
    .from('calibration_blocks')
    .select('*')
    .eq('calibration_id', calibration_id)
    .order('created_at', { ascending: true });
  if (error) throw error;
  return data || [];
}

export async function deleteBlock(block_id) {
  const { error } = await supabase
    .from('calibration_blocks')
    .delete()
    .eq('id', block_id);
  if (error) throw error;
  return true;
}

export async function ensureDefaultMultimeterBlocks(calibration_id) {
  const { data: existing } = await supabase
    .from('calibration_blocks')
    .select('id')
    .eq('calibration_id', calibration_id)
    .limit(1);

  if (existing && existing.length) {
    const { data } = await supabase
      .from('calibration_blocks')
      .select('*')
      .eq('calibration_id', calibration_id)
      .order('created_at', { ascending: true });
    return data || [];
  }

  const defaults = [
    { mode: 'VDC', unit: 'V', display_name: 'Voltaje DC' },
    { mode: 'VAC', unit: 'V', display_name: 'Voltaje AC' },
    { mode: 'ADC', unit: 'A', display_name: 'Corriente DC' },
    { mode: 'AAC', unit: 'A', display_name: 'Corriente AC' },
    { mode: 'OHM', unit: 'Ω', display_name: 'Resistencia' },
    { mode: 'HZ', unit: 'Hz', display_name: 'Frecuencia' },
  ];

  const payload = defaults.map((d) => ({ calibration_id, block_type: 'standard_comparison', ...d }));
  const { data, error } = await supabase
    .from('calibration_blocks')
    .insert(payload)
    .select('*');
  if (error) throw error;
  return data || [];
}
